import { difference } from "lodash";

export const tractorMonthlySheetValidator = (data, jdMonthDates) => {
  var finalHeaders = new Set(Object.keys(data[0]));
  var unwantedHeaders = [
    "Market",
    "Country",
    "Total month",
    "W1 Actual",
    "W2 Actual",
    "W3 Actual",
    "W4 Actual",
    "W5 Actual",
  ];
  for (let i = 0; i < unwantedHeaders.length; i++) {
    finalHeaders.delete(unwantedHeaders[i]);
  }
  if (difference(Array.from(finalHeaders), jdMonthDates).length === 0) {
    return true;
  }
  return false;
};

export const aggregateMonthlySheetValidator = (data, jdMonthDates) => {
  var finalHeaders = new Set(Object.keys(data[0]));
  var unwantedHeaders = [
    "Container type",
    "Country",
    "Total cntr",
    "W1 Actual",
    "W2 Actual",
    "W3 Actual",
    "W4 Actual",
    "W5 Actual",
  ];
  for (let i = 0; i < unwantedHeaders.length; i++) {
    finalHeaders.delete(unwantedHeaders[i]);
  }

  if (difference(Array.from(finalHeaders), jdMonthDates).length === 0) {
    return true;
  }
  return false;
};

export const fiveMMonthlySheetValidator = (data, jdMonthDates) => {
  var finalHeaders = new Set(Object.keys(data[0]));
  var unwantedHeaders = [
    "Destination",
    "Region",
    "Total month",
    "W1 Actual",
    "W2 Actual",
    "W3 Actual",
    "W4 Actual",
    "W5 Actual",
  ];
  for (let i = 0; i < unwantedHeaders.length; i++) {
    finalHeaders.delete(unwantedHeaders[i]);
  }
  if (difference(Array.from(finalHeaders), jdMonthDates).length === 0) {
    return true;
  }
  return false;
};

export const ErrorMsg=(err) =>
{
  let msg;
  if(err.length  <= 2 )
      {
         msg=`The container for this (${err})  booking has already been mark as "factory gate out" therefore, it cannot be deleted.`
      }
      else
      {
        msg=`The container for the selected booking(s) has already been marked as 'factory gate out,' therefore, it cannot be deleted.`
      }
      return msg

}